import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ModalConsultaAjustadoresComponent } from '../../@modals/modal-consulta-ajustadores/modal-consulta-ajustadores.component';
import { skipWhile, Subscription, take } from 'rxjs';
import { ConsultaSiniestroOutput, SiniestroDet } from 'src/app/models/complementos-web/complementos-web.model';
import { selectObjetoDetalleSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { AppState } from 'src/app/@store/app.reducers';
import { Store } from '@ngrx/store';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { NgClass } from '@angular/common';
import { MatMiniFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatCheckbox } from '@angular/material/checkbox';


@Component({
    selector: 'app-detalle-conductor-siniestro',
    templateUrl: './detalle-conductor-siniestro.component.html',
    styleUrls: ['./detalle-conductor-siniestro.component.scss'],
    imports: [NgClass, MatMiniFabButton, MatIcon, FormsModule, ReactiveFormsModule, MatCheckbox]
})
export class DetalleConductorSiniestroComponent implements OnInit {

  public formDetalleAdicionales: FormGroup;
  public screenSize: string = '';

  public detalleComplementoSiniestro: ConsultaSiniestroOutput;
  public siniestroCompleto: SiniestroDet;
  public listaObservables: Array<Subscription> = [];

  constructor(
    private dialog: MatDialog,
    private procesosComplementoService: ProcesosComunesComplementoService,
    private store: Store<AppState>,
  ) {
    this.cargarFormulario();
    this.tamanoPantalla();
  }

  ngOnInit(): void {
    this.onReduxChange();
  }

  ngOnDestroy(): void {
    this.listaObservables.forEach(obs => obs.unsubscribe());
  }

  tamanoPantalla() {
    const subScreen = this.procesosComplementoService.screenSize$.subscribe(size => {
      this.screenSize = size;
    });
    this.listaObservables.push(subScreen);
  }

  cargarFormulario() {
    this.formDetalleAdicionales = new FormGroup({
      lesionados: new FormControl({ value: null, disabled: true }),
      homicidio: new FormControl({ value: null, disabled: true })
    });
  }

  setearValoresLesionados() {
    this.formDetalleAdicionales.patchValue({
      lesionados: this.siniestroCompleto.lesionados == 1 ? true : false,
      homicidio: this.siniestroCompleto.homicidio == 1 ? true : false
    });
  }

  onReduxChange() {
    const complementoWeb = this.store.select(selectObjetoDetalleSiniestroSiniestros).pipe(skipWhile(datos => datos == null)).subscribe({
      next: (value: ConsultaSiniestroOutput) => {
        this.detalleComplementoSiniestro = value;
        this.siniestroCompleto = value.Siniestro[0];
        this.setearValoresLesionados();
      },
    })
    this.listaObservables.push(complementoWeb);
  }


  abrirModalAjustadores() {
    const dialog = this.dialog.open(ModalConsultaAjustadoresComponent, {
      width: '550px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: {},
    }).afterClosed().pipe(take(1)).subscribe(data => {

    });
  }
}
